import { useNavigate } from "react-router-dom"
import ActionButtonGradient from "../../../../components/button/ActionButtonGradient"

const PhaseDeadline = ({ project_id, phases }) => {
    const navigate = useNavigate()

    const formatDate = (dateString) => {
        return new Date(dateString).toISOString().split('T')[0]
    }

    return (
        <div>
            <div className="d-flex justify-content-end my-3">
                <ActionButtonGradient
                    onClick={() => navigate(`/project-list/project/phase/${project_id}`)}
                    variant="primary"
                    children={"Configure Phase"}
                />
            </div>

            <div className="table-responsive">
                <table className="table align-items-center">
                    <thead>
                        <tr>
                            {phases?.map((phase, index) => (
                                <th key={index} scope="col">{phase.Phase.Name}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {phases?.map((phase, index) => (
                                <td key={index}>
                                    {formatDate(phase.StartDate)} to {formatDate(phase.EndDate)}
                                </td>
                            ))}
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default PhaseDeadline